import { gql } from 'apollo-boost';

export const COURSE_DELETE = gql`
  mutation CourseDelete($courseId: ID!) {
    course_delete(input: { id: $courseId }) {
      message
    }
  }
`;
